// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-272294c8] .el-dialog__body{overflow:auto!important}[data-v-272294c8] .el-input-number .el-input__inner{text-align:left!important}.warn-text[data-v-272294c8]{margin:10px 0;font-size:15px;font-weight:600}", ""]);
// Exports
module.exports = exports;
